export default __webpack_public_path__ + "static/strategy-f64a9efb1712abbe740c982ccdbd9618.jpg";